import React, { Fragment } from 'react'
import slideUno from "../images/carros/carro_6.webp"
import slideDos from "../images/carros/carro_1.webp"
import slideTres from "../images/carros/carro_2.webp"
import slide4 from "../images/carros/carro_3.webp"
import slide5 from "../images/carros/carro_4.webp"
import slide6 from "../images/carros/carro_5.webp"

export const Nosotros = () => {
    return (
        <Fragment>
            <div className='contenedorNosotros'>
                    <div className='containerImg'>
                <div className='ContenedorAboutUs'>
                        <h2 className='heading'>Nosotros</h2>
                        <p className='text'>Somos un negocio familiar que ofrece sus servicios en los condados de Broward y Miami Dade.
                            Nuestro enfoque es proveer a nuestros estudiantes el acompañamiento y asesoría de la mas alta calidad,
                            empezando por nuestros instructores quienes son profesionales dedicados a enseñar todo su conocimiento y
                            experiencia y así convertir de nuestros estudiantes los más hábiles y responsables conductores de por vida.
                        </p>
                    </div>
                    <div className='contenedorCarrusel'>
                        <div id="carrusel" className="carousel slide carousel-fade" data-bs-ride="carousel" data-interval="3000">
                            <div className="carousel-inner">
                                <div className="carousel-item active">
                                    <img src={slideDos} className="d-block w-100" alt="..." />
                                </div>
                                <div className="carousel-item">
                                    <img src={slide5} className="d-block w-100" alt="..." />
                                </div>
                                <div className="carousel-item">
                                    <img src={slideTres} className="d-block w-100" alt="..." />
                                </div>
                                <div className="carousel-item">
                                    <img src={slide4} className="d-block w-100" alt="..." />
                                </div>
                                <div className="carousel-item">
                                    <img src={slideUno} className="d-block w-100" alt="..." />
                                </div>
                                <div className="carousel-item">
                                    <img src={slide6} className="d-block w-100" alt="..." />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='boxShadow'></div>
            </div>
        </Fragment>
    )
}
export default Nosotros;